import { Component, computed, input, output } from '@angular/core';
import { ButtonComponent, IconComponent, TypographyComponent } from '@purolator/ui-kit-angular';
import { TranslatePipe } from '../../../../core/i18n';
import { AlertToast } from '../../../../shared/components/alert-toast/alert-toast';

export type LabelGenerationState = 'processing' | 'ready' | 'failed';

/** Shipping-label card for processing, ready, and retry states. */
@Component({
  selector: 'app-get-labels-label-ready',
  imports: [AlertToast, ButtonComponent, IconComponent, TranslatePipe, TypographyComponent],
  templateUrl: './get-labels-label-ready.html',
  styleUrl: './get-labels-label-ready.scss',
  host: {
    '[attr.aria-busy]': "state() === 'processing' ? 'true' : null",
  },
})
export class GetLabelsLabelReady {
  readonly trackingPin = input.required<string>();
  readonly state = input<LabelGenerationState>('ready');
  readonly showGenerationError = input(false);
  readonly actionRequested = output<void>();

  /** Ties failed retry copy to the View/Download control for assistive tech. */
  protected readonly failureStatusId = 'get-labels-label-failure-status';

  protected readonly isReady = computed(() => this.state() !== 'processing');

  /**
   * Requests label status retrieval / retry while ignoring clicks during loading.
   */
  protected onAction(): void {
    if (this.state() !== 'processing') {
      this.actionRequested.emit();
    }
  }
}
